import { render, staticRenderFns } from "./TJdocMarkdown.vue?vue&type=template&id=60eeb966&scoped=true"
import script from "./TJdocMarkdown.vue?vue&type=script&lang=ts"
export * from "./TJdocMarkdown.vue?vue&type=script&lang=ts"
import style0 from "./TJdocMarkdown.vue?vue&type=style&index=0&id=60eeb966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eeb966",
  null
  
)

export default component.exports